
import LikeIcon from "../assets/images/reaction/like.svg";
import LoveIcon from "../assets/images/reaction/love.svg";
import HahaIcon from "../assets/images/reaction/haha.svg";
import WowIcon from "../assets/images/reaction/wow.svg";
import SadIcon from "../assets/images/reaction/sad.svg";
import AngryIcon from "../assets/images/reaction/angry.svg";

export const REACTIONS = [
  { label: "좋아요", key: "like", icon: LikeIcon },
  { label: "사랑", key: "love", icon: LoveIcon },
  { label: "웃음", key: "haha", icon: HahaIcon },
  { label: "놀람", key: "wow", icon: WowIcon },
  { label: "슬퍼요", key: "sad", icon: SadIcon },
  { label: "화나요", key: "angry", icon: AngryIcon },
];
